export enum LocalStorageNames {
  PPS_ACCOUNT = `pps-account`,
}
